<script setup lang="ts">
import { ref } from 'vue'
import { FilterField, TableAction, TableField } from "../../../../components/table/table";
import { Permission } from '../../../../types/auth'
import ListTemplate from "../../../../components/ui/common/ListTemplate.vue";
import UpdateExchangeRateModal from '../currency/UpdateExchangeRateModal..vue';

withDefaults(defineProps<{
  showHeader?: boolean,
  showQuickTour?: boolean,
  showTitle?: boolean,
  showNextButton?: boolean
  perm?: Permission[]
}>(), {
  showHeader: true,
  showQuickTour: true,
  showTitle: true
})

const endPoint = '/clients/finance/master-data/exchange-rates/'
const title = 'Exchange Rates'
const selectedData = ref<any | null>(null)
const showForm = ref(false)
const formMode = ref<'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'>('view')
const refreshData = ref(false)

const fields: TableField[] = [
  { name: 'name', caption: 'Currency', sortable: false, fieldType: 'text' },
  { name: 'from_date', caption: 'From Date', sortable: true, fieldType: 'date' },
  { name: 'to_date', caption: 'To Date', sortable: true, fieldType: 'date' },
  { name: 'rate', caption: 'Exchange Rate', sortable: true, fieldType: 'number', width: '150px' },
]

const actions: TableAction[] = [
{ name: 'update-exchange-rates', icon: 'CircleDollarSign', variant: 'primary', title: 'Update Exchange Rates' },
]
const filterFields: FilterField[] = [
  {
    name: 'active',
    label: 'Status',
    type: 'select',
    value: '',
     options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
]

const permissions = ref<Permission[]>()

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleData = (data : any) => {
  selectedData.value = data
  console.log(selectedData.value)
}
</script>

<template>
  <ListTemplate :endPoint = "endPoint" :title = "title" :fields = "fields" :actions = "actions" :filterFields ="filterFields"
  :tabList = "[]" :refreshData = "refreshData" custom-url="/clients/finance/master-data/currency/exchange-rates" @mode="changeMode" @show="showForm = true" :showForm="showForm" @permissions="permissions = $event"
  @data="handleData" :show-header="showHeader" :show-quick-tour="showQuickTour" :show-title="showTitle" :show-next-button="showNextButton">
  <template #form-view>
    <UpdateExchangeRateModal
      :permissions="permissions"
      v-if="showForm"
      :data="selectedData"
      :end-point="endPoint"
      :title="title"
      :mode="formMode"
      @save="refreshData = !refreshData"
      @close="showForm = !showForm"
    />
  </template>
  </ListTemplate>
</template>